export const authBus = {
  onUnauthorized(callback: () => void) {
    window.addEventListener('unauthorized', callback);
  },
  offUnauthorized(callback: () => void) {
    window.removeEventListener('unauthorized', callback);
  },
  fireUnauthorized() {
    window.dispatchEvent(new Event('unauthorized'));
  },
  onLoginRequired(callback: () => void) {
    window.addEventListener('login-required', callback);
  },
  offLoginRequired(callback: () => void) {
    window.removeEventListener('login-required', callback);
  },
  fireLoginRequired() {
    window.dispatchEvent(new Event('login-required'));
  },
  onInviteCodeRequired(callback: () => void) {
    window.addEventListener('invite-code-required', callback);
  },
  offInviteCodeRequired(callback: () => void) {
    window.removeEventListener('invite-code-required', callback);
  },
  fireInviteCodeRequired() {
    window.dispatchEvent(new Event('invite-code-required'));
  },
  onLoginSuccess(callback: () => void) {
    window.addEventListener('login-success', callback);
  },
  offLoginSuccess(callback: () => void) {
    window.removeEventListener('login-success', callback);
  },
  fireLoginSuccess() {
    window.dispatchEvent(new Event('login-success'));
  },
  onLoginCancelled(callback: () => void) {
    window.addEventListener('login-cancelled', callback);
  },
  offLoginCancelled(callback: () => void) {
    window.removeEventListener('login-cancelled', callback);
  },
  fireLoginCancelled() {
    window.dispatchEvent(new Event('login-cancelled'));
  },
  onInvalidInvitation(callback: EventListenerOrEventListenerObject) {
    window.addEventListener('invalid-invitation', callback);
  },
  offInvalidInvitation(callback: EventListenerOrEventListenerObject) {
    window.removeEventListener('invalid-invitation', callback);
  },
  fireInvalidInvitation(message: string) {
    window.dispatchEvent(new CustomEvent('invalid-invitation', { detail: { message } }));
  },
};
